import CloseIcon from "@/assets/images/icons/close.svg?inline";

export default {
  name: "promo-ghm-banner",

  data() {
    return {};
  },

  // props: [],

  // mounted: function() {},

  methods: {
    hidePromoBanner() {
      localStorage.setItem("promoGHM", false);
      this.$emit("hidePromoGHM");
    }
  },

  components: {
    CloseIcon
  }
};
